import React from 'react';
import CalendarSVG from '../../Icons/EventsIcons/Calendar';
import EventTypeSVG from '../../Icons/EventsIcons/EventType';
import {
    dropdownEventsTypeList,
    eventEndPointBaseUrl,
    monthNames,
} from '../../Includes/Constants/events';
import TitleWithUnderlineSubnav from '../../Layout/TitleWithUnderlineSubnav/TitleWithUnderlineSubnav';
import { getConsecutiveMonthParams } from '../helperFunctions';
import DropdownMenu from './DropdownMenu/DropdownMenu';

import './EventsFilterHeader.scss';

export default class EventsFilterHeader extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            currentEventStatus: 'upcoming',
            currentParams: [],
            headerMenuItems: [
                {
                    text: 'Upcoming Events',
                    url: `${eventEndPointBaseUrl}eventStatus=upcoming`,
                    active: true,
                },
                {
                    text: 'Past Events',
                    url: `${eventEndPointBaseUrl}eventStatus=past`,
                    active: false,
                },
            ],
            dropdownMonthYearList: getConsecutiveMonthParams({
                currentTime: new Date(),
                numToGenerate: 6,
                futureMonths: true,
                orderByRecent: true,
            }),
        };
        this.headerTitle = 'Events Calendar';
    }

    componentDidMount() {
        const currentLocationQuery = window.location.search;
        if (currentLocationQuery.includes('=')) {
            this.setCurrentParams(currentLocationQuery);
        }
    }

    setCurrentParams = (currentLocationQuery) => {
        const currentParams = currentLocationQuery.split('&').map((query) => {
            const paramObj = this.constructParamObj(query);
            if (paramObj.queryName === 'eventStatus') {
                this.updateEventStatusMenu(paramObj.queryValue);
            }
            return paramObj;
        });
        this.setState({
            currentParams: currentParams,
        });
    };

    constructParamObj = (query) => {
        if (!query) {
            return {};
        }
        const paramObj =
            query &&
            (/^[?#]/.test(query) ? query.slice(1) : query)
                .split('&')
                .reduce((params, param) => {
                    let [key, value] = param.split('=');
                    params.queryName = key;
                    params.queryValue = value
                        ? decodeURIComponent(value.replace(/\+/g, ' '))
                        : '';
                    return params;
                }, {});
        return paramObj;
    };

    updateEventStatusMenu = (currentEventStatus) => {
        this.setState({
            currentEventStatus: currentEventStatus,
            headerMenuItems: [
                {
                    text: 'Upcoming Events',
                    url: `${eventEndPointBaseUrl}eventStatus=upcoming`,
                    active: currentEventStatus === 'upcoming',
                },
                {
                    text: 'Past Events',
                    url: `${eventEndPointBaseUrl}eventStatus=past`,
                    active: currentEventStatus === 'past',
                },
            ],
            dropdownMonthYearList: getConsecutiveMonthParams({
                currentTime: new Date(),
                numToGenerate: 6,
                futureMonths: currentEventStatus === 'upcoming',
                orderByRecent: true,
            }),
        });
    };

    getSelectedFilterText = (paramNames) => {
        const { currentParams } = this.state;
        const selectedText = [];
        currentParams.forEach((param) => {
            if (paramNames.includes(param.queryName)) {
                param.queryName === 'month'
                    ? selectedText.push(monthNames[param.queryValue - 1])
                    : selectedText.push(param.queryValue);
            }
        });
        return selectedText.join(' ');
    };

    createParamsForAll = (paramsToRemoveForAll) => {
        const { currentParams } = this.state;
        const paramsRemovedForAll = [];
        currentParams.forEach(
            (param) =>
                !paramsToRemoveForAll.includes(param.queryName) &&
                paramsRemovedForAll.push(param)
        );
        return paramsRemovedForAll;
    };

    render() {
        const {
            currentParams,
            headerMenuItems,
            currentEventStatus,
            dropdownMonthYearList,
        } = this.state;
        const eventDisplayText =
            this.getSelectedFilterText(['eventType']) || 'Filter by event type';
        const monthYearDisplayText =
            this.getSelectedFilterText(['month', 'year']) ||
            'Filter by month and year';
        const eventParamsForAll = this.createParamsForAll(['eventType']);
        const monthYearParamsForAll = this.createParamsForAll([
            'month',
            'year',
        ]);
        return (
            <div className="component-Events-EventsFilterHeader">
                <TitleWithUnderlineSubnav
                    title={this.headerTitle}
                    menuItems={headerMenuItems}
                />
                <div className="dropdown-section">
                    <DropdownMenu
                        placeHolderIcon={CalendarSVG}
                        displayText={eventDisplayText}
                        dropdownMenu={dropdownEventsTypeList}
                        currentParams={currentParams}
                        currentEventStatus={currentEventStatus}
                        paramsForAll={eventParamsForAll}
                        displayTextForAll="All event types"
                    />
                    <DropdownMenu
                        placeHolderIcon={EventTypeSVG}
                        displayText={monthYearDisplayText}
                        dropdownMenu={dropdownMonthYearList}
                        currentParams={currentParams}
                        currentEventStatus={currentEventStatus}
                        paramsForAll={monthYearParamsForAll}
                        displayTextForAll="All dates"
                    />
                </div>
            </div>
        );
    }
}
